import React from "react";

const GoogleFormsIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.5408 10L30.0249 11.0364L34.5408 10L24.5408 0L23.1613 4.74091L24.5408 10Z",
  fill: "#56368A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.5409 10V0H8.17722C6.67041 0 5.44995 1.22045 5.44995 2.72727V37.2727C5.44995 38.7795 6.67041 40 8.17722 40H31.8136C33.3204 40 34.5409 38.7795 34.5409 37.2727V10H24.5409Z",
  fill: "#7248B9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.1772 28.8637C12.425 28.8637 11.8136 28.2523 11.8136 27.5C11.8136 26.7477 12.425 26.1364 13.1772 26.1364C13.9295 26.1364 14.5409 26.7477 14.5409 27.5C14.5409 28.2523 13.9295 28.8637 13.1772 28.8637ZM13.1772 23.4091C12.425 23.4091 11.8136 22.7977 11.8136 22.0455C11.8136 21.2932 12.425 20.6818 13.1772 20.6818C13.9295 20.6818 14.5409 21.2932 14.5409 22.0455C14.5409 22.7977 13.9295 23.4091 13.1772 23.4091ZM13.1772 17.9546C12.425 17.9546 11.8136 17.3432 11.8136 16.5909C11.8136 15.8387 12.425 15.2273 13.1772 15.2273C13.9295 15.2273 14.5409 15.8387 14.5409 16.5909C14.5409 17.3432 13.9295 17.9546 13.1772 17.9546ZM28.1772 28.6364H16.8136V26.3637H28.1772V28.6364ZM28.1772 23.1818H16.8136V20.9091H28.1772V23.1818ZM28.1772 17.7273H16.8136V15.4546H28.1772V17.7273Z",
  fill: "white"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(GoogleFormsIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;